// extracted by mini-css-extract-plugin
module.exports = {"addressVerificationModal":"_2Yzm-k","description":"_3Ykb71"};